import React from "react";
import { Divider } from "@material-ui/core";
import PriceCalculation from "./PriceCalculation";
import ArchiveFactorDialog from "./components/ArchiveFactorDialog/ArchiveFactorDialog";
import ConvertDialog from "./components/ConvertDialog/ConvertDialog";
import ServiceDialog from "./components/ServiceDialog/ServiceDialog";
import FactorDescription from "./components/FactorDescription/FactorDescription";
import PageTitle from "Components/PageTitle/PageTitle";
import Translator from "Languages/Utility/Translator";
import FactorPreview from "./FactorPreview";

export default function FactorsButton({ disabled }) {
  return (
    <div className="page-top-title-button my-2">
      <PageTitle title={<Translator id="invoices" />} />
      <div className="top-buttons">
        <PriceCalculation disabled={disabled} />
        <FactorPreview disabled={disabled} />
        <Divider
          orientation="vertical"
          flexItem
          className="mx-1 divider-factor"
        />
        <ArchiveFactorDialog disabled={disabled} />
        <ConvertDialog disabled={disabled} />
        <ServiceDialog disabled={disabled} />
        <FactorDescription disabled={disabled} />
      </div>
    </div>
  );
}
